(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["glaam-card-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('glaam-card-gallery')) {
    customElements.define('glaam-card-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.track = this.querySelector('.glaam-card-gallery__track');
        this.slides = [...this.querySelectorAll('.glaam-card-gallery__slide')];
        this.dots = [...this.querySelectorAll('[data-index]')];
        if (!this.track || this.slides.length < 2) return;
        this.current = 0;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.track.addEventListener('scroll', () => this.onScroll(), { passive: true, signal });
        this.track.addEventListener('pointerdown', (event) => {
          this.pointer = { x: event.clientX, y: event.clientY, moved: false };
          this.loadImage(this.current - 1);
          this.loadImage(this.current + 1);
        }, { passive: true, signal });
        this.track.addEventListener('pointermove', (event) => {
          if (!this.pointer) return;
          const x = Math.abs(event.clientX - this.pointer.x);
          const y = Math.abs(event.clientY - this.pointer.y);
          if (x > 10 && x > y) this.pointer.moved = true;
        }, { passive: true, signal });
        const endPointer = () => {
          if (this.pointer?.moved) this.suppressClickUntil = Date.now() + 500;
          this.pointer = null;
        };
        window.addEventListener('pointerup', endPointer, { passive: true, signal });
        window.addEventListener('pointercancel', endPointer, { passive: true, signal });
        this.track.addEventListener('click', (event) => {
          if (Date.now() < (this.suppressClickUntil || 0)) {
            event.preventDefault();
            event.stopPropagation();
          }
        }, { capture: true, signal });
        this.addEventListener('click', (event) => {
          const button = event.target.closest('button[data-index], button[data-step]');
          if (!button || !this.contains(button)) return;
          event.preventDefault();
          event.stopPropagation();
          this.goTo(button.hasAttribute('data-index') ? Number(button.dataset.index) : this.current + Number(button.dataset.step));
        }, { signal });
        this.track.addEventListener('keydown', (event) => {
          if (event.altKey || event.ctrlKey || event.metaKey) return;
          const targets = { ArrowLeft: this.current - 1, ArrowRight: this.current + 1, Home: 0, End: this.slides.length - 1 };
          if (!(event.key in targets)) return;
          event.preventDefault();
          this.goTo(targets[event.key]);
        }, { signal });
        this.resizeObserver = new ResizeObserver(() => {
          if (this.track.clientWidth) this.track.scrollTo({ left: this.current * this.track.clientWidth, behavior: 'instant' });
        });
        this.resizeObserver.observe(this.track);
        this.setAttribute('data-ready', '');
        this.onScroll();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.frame);
        this.controller = null;
        this.removeAttribute('data-ready');
      }

      loadImage(index) {
        const template = this.slides[index]?.querySelector('template');
        if (template) template.replaceWith(template.content.cloneNode(true));
      }

      goTo(index) {
        const target = Math.max(0, Math.min(index, this.slides.length - 1));
        this.loadImage(target);
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
        this.track.scrollTo({ left: target * this.track.clientWidth, behavior });
      }

      onScroll() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          const width = this.track.clientWidth;
          if (!width) return;
          const position = this.track.scrollLeft / width;
          this.loadImage(Math.floor(position));
          if (position % 1 > .01) this.loadImage(Math.ceil(position));
          const index = Math.max(0, Math.min(Math.round(position), this.slides.length - 1));
          this.slides.forEach((slide, i) => {
            slide.tabIndex = i === index ? 0 : -1;
            slide.setAttribute('aria-hidden', String(i !== index));
          });
          this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
          this.querySelector('[data-step="-1"]').disabled = index === 0;
          this.querySelector('[data-step="1"]').disabled = index === this.slides.length - 1;
          if (index !== this.current) this.querySelector('[data-gallery-status]').textContent = this.dots[index].getAttribute('aria-label');
          this.current = index;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
